import React from 'react';

import {
  Box,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Text,
} from '@chakra-ui/react';

import ReactCountryFlag from 'react-country-flag';

import {useSelectedCountry} from '../contexts/CountryContext';
import {getCountryCode} from '../utils/countryMappings';

export function CountrySelector() {
  const {selectedCountry, setSelectedCountry, countries, isLoading} =
    useSelectedCountry();

  if (!isLoading && countries.length <= 1) {
    return null;
  }

  if (isLoading) {
    return (
      <HStack>
        <Spinner size='sm' />
      </HStack>
    );
  }

  if (!selectedCountry) {
    return null;
  }

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={
          <ReactCountryFlag
            countryCode={getCountryCode(selectedCountry.id)}
            svg
            cdnUrl='https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/'
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
            title={selectedCountry.name}
          />
        }
        isRound
        variant='ghost'
        aria-label={`País seleccionado: ${selectedCountry.name}`}
        w={12}
        h={12}
        _focus={{
          boxShadow: 'none',
          outline: 'none',
        }}
      />
      <MenuList maxH='300px' overflowY='auto' bg='white'>
        {countries.map(country => (
          <MenuItem
            key={country.id}
            onClick={() => setSelectedCountry(country)}
            bg={selectedCountry?.id === country.id ? 'blue.50' : undefined}
            _hover={{bg: 'gray.100'}}>
            <HStack spacing={3} w='100%'>
              <ReactCountryFlag
                countryCode={getCountryCode(country.id)}
                svg
                style={{
                  width: '1.2em',
                  height: '1.2em',
                  borderRadius: '2px',
                }}
                title={country.name}
                aria-label={country.name}
              />
              <Box flex={1}>
                <Text
                  fontWeight={
                    selectedCountry?.id === country.id ? 'bold' : 'normal'
                  }>
                  {country.name}
                </Text>
              </Box>
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
